export const getters = {
  FORM_OPTIONS: (state) => state.formOptions,
  POSITIONS: (state) => state.positions,
  REGIONS: (state) => state.regions,
  CATEGORIES: (state) => state.categories,
  COMPANY_STATUSES: (state) => state.companyStatuses
}
